module.exports = __webpack_public_path__ + "img/cronic-disease.455d7ce7.svg";